import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';

import { ContentSkeleton } from './subcomponents/Skeletons';
import { emtContentDataModel } from './dataModels';
import { propTypesEmtQuestionsAndAnswers } from './QuestionsAndAnswers/constants';

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(
      require.resolveWeak('./QuestionsAndAnswers/EmtQuestionsAndAnswers')
    ).EmtQuestionsAndAnswersComponent;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "emt-questions-and-answers-component" */
      './QuestionsAndAnswers/EmtQuestionsAndAnswers');
  },
  placeholder: (<ContentSkeleton />),
  name: 'EmtQuestionsAndAnswersComponent',
});

const HydratedEmtQuestionsAndAnswers = withHydrator({
  id: 'emt-questions-and-answers',
  scrollBuffer: 750,
  delay: 2000,
  preserveCtxVal: 'clientStore',
  placeholder: (<ContentSkeleton />)
}, ImportedComponent);

const DynamicEmQuestionsAndAnswers = withDynamicComponent(HydratedEmtQuestionsAndAnswers);
export const EmtQuestionsAndAnswersImporter = withErrorBoundary(DynamicEmQuestionsAndAnswers);

EmtQuestionsAndAnswersImporter.displayName = 'EmtQuestionsAndAnswersImporter';
EmtQuestionsAndAnswersImporter.dataModel = emtContentDataModel;
EmtQuestionsAndAnswersImporter.propTypes = propTypesEmtQuestionsAndAnswers;